export default {
  label: {
    label: 'Label',
    placeholder: 'Add label',
    system: {
      name: 'label',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'label',
    rules: {
      title: 'Label field',
      required: true,
    }
  },
  description: {
    label: 'Description',
    placeholder: 'Fill-in this field',
    system: {
      name: 'description',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'description',
    rules: {
      title: 'Description',
      required: true,
    }
  },
  shop_id: {
    label: 'Assign Shop',
    placeholder: '',
    system: {
      name: 'shop_id',
    },
    value: "",
    errors: [],
    type: 'select',
    name: 'shop_id',
    rules: {}
  },
  project_ids: {
    label: 'Assign Projects (NOTE: Selected projects tasks will be automatically queued in this lane)',
    placeholder: '',
    system: {
      name: 'project_ids',
    },
    value: [],
    errors: [],
    type: 'text',
    name: 'project_ids',
    rules: {
      title: '',
      required: false,
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/AddLane/fields.js